import { render, staticRenderFns } from "./memberPc.vue?vue&type=template&id=5952f827&scoped=true&"
import script from "./memberPc.vue?vue&type=script&lang=js&"
export * from "./memberPc.vue?vue&type=script&lang=js&"
import style0 from "./memberPc.vue?vue&type=style&index=0&id=5952f827&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5952f827",
  null
  
)

export default component.exports